const FORM_STATE_KEY_NULL_SEGMENT = '__null__';
const FORM_STATE_KEY_SEPARATOR = '::';
const FORM_STATE_KEY_TARGET_JOIN = '|';

const stringifyTarget = target => {
  if (target == null) {
    return FORM_STATE_KEY_NULL_SEGMENT;
  }

  if (Array.isArray(target)) {
    return target.length
      ? [...target].sort().join(FORM_STATE_KEY_TARGET_JOIN)
      : FORM_STATE_KEY_NULL_SEGMENT;
  }

  return target;
};

export const buildFormStateKey = ({ target, targetEntityId }) =>
  [stringifyTarget(target), targetEntityId ?? FORM_STATE_KEY_NULL_SEGMENT].join(
    FORM_STATE_KEY_SEPARATOR,
  );
